import { FC, useRef } from 'react';
import { API } from '@brg/api';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import ResizedImageEnhanced from '../../../../components/ResizedImageEnhanced';
import { IContentViewItem } from '../../../../hooks/api/useContentView';
import { useContentViewTracking } from '../../../../hooks/api/useContentViewTracking';
import { LayoutConst } from 'core';
import { AdLegalHintTooltip } from './AdLegalHintTooltip';

const Wrapper = styled.a`
  display: flex;
  flex-direction: column;
  width: calc(100% - 24px);
  margin-left: 24px;
  text-decoration: none;
  color: inherit;
  box-sizing: border-box;
  position: relative;


  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      width: 340px;
      margin-left: auto;
  }
  @media (max-width: ${LayoutConst.screen.s}px) {
    width: 100%;
    margin-left: 0;
    margin-top: 16px;
  }
`;

const Image = styled(ResizedImageEnhanced)`
  width: 100%;
  margin-bottom: 10px;

  img {
    width: 100%;
    height: auto;
    object-fit: contain;
  }
`;

const Title = styled.span`
  font-family: Inter, sans-serif;
  font-size: 17px;
  font-weight: 600;
  line-height: 22px;
  color: ${({ theme }) => theme.app.text};
  letter-spacing: -0.3px;
  margin-bottom: 5px;
  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 15px;
    line-height: 20px;
  }
`;

const SubTitle = styled.span`
  font-family: Inter, sans-serif;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  color: ${({ theme }) => theme.approvalBlockStyles.color};
  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 13px;
    line-height: 17px;
  }
  @media (max-width: ${LayoutConst.screen.m}px) {
    font-size: 11px;
    line-height: 15px;
  }
`;

const Badge = styled.span`
  background: rgba(49, 49, 49, 0.4);
  border-radius: 3px;
  padding: 6px 18px;
  font-size: 12px;
  line-height: 1.2;
  color: #cdcdcd;
  backdrop-filter: blur(4px);
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 2;
`;

interface AdCardProps {
    adItem: IContentViewItem;
    vtype?: string;
    projectId?: string;
}

const StartingAdBlock: FC<AdCardProps> = ({ adItem, vtype, projectId }) => {
  const { i18n, t } = useTranslation();
  const localized = API.lang<IContentViewItem>(adItem, i18n.language);
  
  const wrapperRef = useRef<HTMLAnchorElement>(null);

  const { trackClick } = useContentViewTracking({
    adItem,
    projectId,
    position: 0,
    elementRef: wrapperRef,
    componentName: 'StartingAdBlock',
  });

  if (['fluid-wide', 't-shape', 'fixed-ratio-large', 'free-type'].includes(String(vtype))) {
      return null;
  }

  return (
      <AdLegalHintTooltip adItem={adItem}>
          <Wrapper className="starting-ad-block" ref={wrapperRef} href={adItem.link} target="_blank" rel="noopener noreferrer" onClick={trackClick} onAuxClick={trackClick} onContextMenu={trackClick}>
              {adItem.files?.length > 0 && (
                  <Image files={adItem.files as any} alt={localized.title as any} />
              )}
              <Badge>{t('advertisement')}</Badge>
              {localized.title && <Title>{localized.title as any}</Title>}
              {localized.subTitle && <SubTitle>{localized.subTitle as any}</SubTitle>}
          </Wrapper>
      </AdLegalHintTooltip>
  );
};

export default StartingAdBlock;
import { FC, useRef } from 'react';
import { API } from '@brg/api';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import ResizedImageEnhanced from '../../../../components/ResizedImageEnhanced';
import { IContentViewItem } from '../../../../hooks/api/useContentView';
import { useContentViewTracking } from '../../../../hooks/api/useContentViewTracking';
import { LayoutConst } from 'core';
import { AdLegalHintTooltip } from './AdLegalHintTooltip';

const Wrapper = styled.a`
  display: flex;
  flex-direction: column;
  width: calc(100% - 24px);
  margin-left: 24px;
  text-decoration: none;
  color: inherit;
  box-sizing: border-box;
  position: relative;


  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      width: 340px;
      margin-left: auto;
  }
  @media (max-width: ${LayoutConst.screen.s}px) {
    width: 100%;
    margin-left: 0;
    margin-top: 16px;
  }
`;

const Image = styled(ResizedImageEnhanced)`
  width: 100%;
  margin-bottom: 10px;

  img {
    width: 100%;
    height: auto;
    object-fit: contain;
  }
`;

const Title = styled.span`
  font-family: Inter, sans-serif;
  font-size: 17px;
  font-weight: 600;
  line-height: 22px;
  color: ${({ theme }) => theme.app.text};
  letter-spacing: -0.3px;
  margin-bottom: 5px;
  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 15px;
    line-height: 20px;
  }
`;

const SubTitle = styled.span`
  font-family: Inter, sans-serif;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  color: ${({ theme }) => theme.approvalBlockStyles.color};
  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 13px;
    line-height: 17px;
  }
  @media (max-width: ${LayoutConst.screen.m}px) {
    font-size: 11px;
    line-height: 15px;
  }
`;

const Badge = styled.span`
  background: rgba(49, 49, 49, 0.4);
  border-radius: 3px;
  padding: 6px 18px;
  font-size: 12px;
  line-height: 1.2;
  color: #cdcdcd;
  backdrop-filter: blur(4px);
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 2;
`;

interface AdCardProps {
    adItem: IContentViewItem;
    vtype?: string;
    projectId?: string;
}

const StartingAdBlock: FC<AdCardProps> = ({ adItem, vtype, projectId }) => {
  const { i18n, t } = useTranslation();
  const localized = API.lang<IContentViewItem>(adItem, i18n.language);
  
  const wrapperRef = useRef<HTMLAnchorElement>(null);

  const { trackClick } = useContentViewTracking({
    adItem,
    projectId,
    position: 0,
    elementRef: wrapperRef,
    componentName: 'StartingAdBlock',
  });

  if (['fluid-wide', 't-shape', 'fixed-ratio-large', 'free-type'].includes(String(vtype))) {
      return null;
  }

  return (
      <AdLegalHintTooltip adItem={adItem}>
          <Wrapper className="starting-ad-block" ref={wrapperRef} href={adItem.link} target="_blank" rel="noopener noreferrer" onClick={trackClick} onAuxClick={trackClick} onContextMenu={trackClick}>
              {adItem.files?.length > 0 && (
                  <Image files={adItem.files as any} alt={localized.title as any} />
              )}
              <Badge>{t('advertisement')}</Badge>
              {localized.title && <Title>{localized.title as any}</Title>}
              {localized.subTitle && <SubTitle>{localized.subTitle as any}</SubTitle>}
          </Wrapper>
      </AdLegalHintTooltip>
  );
};

export default StartingAdBlock;
